import { render } from "./notification-not-logged-in.vue?vue&type=template&id=70cb821f"
import script from "./notification-not-logged-in.vue?vue&type=script&lang=js"
export * from "./notification-not-logged-in.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__